export const SampleSizeLookup = (count: number) => {

    if (count <= 1)
        return 1;
    if (count <= 8)
        return 2;
    if (count <= 15)
        return 3;
    if (count <= 25)
        return 5;
    if (count <= 50)
        return 8;
    if (count <= 90)
        return 13;
    if (count <= 150)
        return 20;
    if (count <= 280)
        return 32;
    if (count <= 500)
        return 50;
    if (count <= 1200)
        return 80;
    if (count <= 3200)
        return 125;
    if (count <= 10000)
        return 200;
    if (count <= 35000)
        return 315;
}
